userCache.$inject = ['$http', '$q', 'configuration']

export default function userCache($http, $q, config) {
  let endPoint = config.root
  let apiEndPoint = config.apiEndPoint
  let ops = ['refresh_accounts', 'refresh_licenses', 'refresh_graph', 'refresh_analytics']

  return {
    async refreshDomainUsers({ domainUuid, userUuids, onOpStartCallback }) {
      let opMetadata = {}
      for (const op of ops) {
        if (onOpStartCallback) {
          onOpStartCallback(op)
        }
        try {
          let opResult
          if (domainUuid && !userUuids) {
            opResult = await this.refreshDomainUsersOp({
              domain: domainUuid,
              op
            })
          } else if (Array.isArray(userUuids)) {
            opResult = await this.refreshUsersOp({
              userUuids,
              op
            })
          }
          opMetadata[op] = opResult
        } catch (err) {
          opMetadata[op] = err
        }
      }
      return opMetadata
    },
    refreshDomainUsersOp({ domain, op }) {
      var deferred = $q.defer()
      $http.post(`${endPoint}user_info/refresh/domain/${domain}/${op}`).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.reject(response.data)
        }
      )
      return deferred.promise
    },
    refreshUsersOp({ userUuids, op }) {
      var deferred = $q.defer()
      $http
        .post(`${endPoint}user_info/refresh`, {
          op: op,
          user_uuids: userUuids
        })
        .then(
          function(response) {
            deferred.resolve(response.data)
          },
          function(response) {
            deferred.reject(response.data)
          }
        )
      return deferred.promise
    },
    fetchNormalizedUsers(domainUuid, schoolUuid, subgroupUuid=null) {
      var deferred = $q.defer()
      var url = `${apiEndPoint}/domain/${domainUuid}/normalized_users?`
      if (schoolUuid) {
        url += 'school=' + schoolUuid
      }
      if (subgroupUuid) {
        url += '&subgroup=' + subgroupUuid
      }
      $http.get(url).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.reject({
            status: 'error',
            message: 'Error: ' + response.data
          })
        }
      )
      return deferred.promise
    }
  }
}
